export default {
  setLocalStorage (key, value, expireTimeInSeconds = 300) {
    const itemValue = {
      data: value,
      timestamp: new Date().getTime(),
      expireTimeInMilliseconds: expireTimeInSeconds * 1000
    }

    localStorage.setItem(key, JSON.stringify(itemValue));
  },

   removeBriefMappingsFromLocalStorage () {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes('brief_mappings')) {
        localStorage.removeItem(key);
      }
    }
  },

  checkLocalStorageLength () {
    let localStoragelength = JSON.stringify(localStorage).length;
    if (localStoragelength > 2000000) {
      this.removeBriefMappingsFromLocalStorage();
    }
  },

  getLocalStorage (key, string) {
    const storageItem = JSON.parse(localStorage.getItem(key));
    if(storageItem) {
      const expiry = storageItem.timestamp + storageItem.expireTimeInMilliseconds;

      if(new Date().getTime() > expiry) {
        this.clearLocalStorageValue(key);
        return null;
      }

      return string ? localStorage.getItem(key).data : JSON.parse(localStorage.getItem(key)).data;
    }
    else {
      return null;
    }
  },

  clearLocalStorageValue (key) {
    return localStorage.removeItem(key);
  },

  clearAllLocalStorage () {
    localStorage.clear();
  }
}